import React, { useState } from "react";
import "./Header.css";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Enquiry_Form_Modal from "../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal";

function Header({ scrollToSection }) {


  const [showModal, setShowModal] = useState(false)

  const navigate = useNavigate();
  const location = useLocation();

  const [expanded, setExpanded] = useState(false); // state to control navbar toggle

  const handleNavClick = () => {
    setExpanded(false);
  };

  // const navItems = [
  //   { label: "Home", path: "/" },
  //   { label: "About", path: "/about-us" },
  //   { label: "Programmes", path: "/programmes" },
  //   { label: "Blogs", path: "/blogs" },
  //   { label: "Contact Us", path: "/contact-us" },
  //   { label: "Admissions", path: "/admissions" },

  // ];

  return (
    <>
      <section className='Header'>
        <div className="inquirybtndiv">
          <button className="inquirybtn" onClick={() => { setShowModal(true) }}>Inquiry</button>
        </div>

        <Container>
          <div className={`main_menu_navbar`}>
            <Navbar
              expand="md"
            >
              <div className="logo_holder">
                <Link to="/">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/logo.png"
                    }
                    alt="logo"
                    className="nav_logo"
                    onClick={() => navigate("/")}
                  />
                </Link>
              </div>

              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
              />

              <Navbar.Collapse id="basic-navbar-nav"
              >
                <div className="top_bar ms-auto">
                  <Nav>

                    {/* {navItems.map((item, index) => ( */}
                    <Nav.Link as={Link} to="/"
                      className={location.pathname === "/" ? "active" : ""}                    >
                      Home
                    </Nav.Link>

                    <Nav.Link onClick={() => { setShowModal(true) }} >
                          Programs
                    </Nav.Link>

                  <Nav.Link onClick={() => { setShowModal(true) }} > Admissions</Nav.Link>

                  <Nav.Link onClick={() => { setShowModal(true) }}> Contact Us</Nav.Link>


                  {/* ))} */}

                </Nav>
              </div>
            </Navbar.Collapse>
          </Navbar>
        </div>

      </Container>

      <Enquiry_Form_Modal
        show={showModal}
        onHide={() => { setShowModal(false) }}
      />
    </section >
    </>
  );
}

export default Header;
